export default {
  loginInfo:{
    memberId:'KR0000002',
  	nm_kr:'관리자',  
    memberType:'DIST',
    memberTitle: 20,
    authKey : '87d394d0327846ac9f01c3f955013524'
  },  
  cartInfo : {
    pd_count: 4,
    total_pv: "80.32",
    payment_amt: "111150"
  },
  aroApplyResult : {},
  aroNtcApplyResult : {},
  memberBirthDt : "",
}



// WEBPACK FOOTER //
// ./src/store/modules/app/state.js